<template>
  <div class="p-20">
    <!--    <img src="../../../public/images/bg.png" class="width-100 fixed z-0">-->
    <div class="">
      <div v-if="errMsg" class="bg-FF p-40 text-center b-r-10">{{ errMsg }}</div>
      <div v-else>
        <div class="bg-FF p-40  b-r-10">
          <div class="cor-33 font-38 font-weight-600">
            {{ formData.title }}
          </div>
          <div class="cor-33 font-30 font-weight-400 m-t-20">
            {{ formData.userName + ' | ' + formData.unitName }}
          </div>
          <div class="cor-66 font-30 font-weight-400 m-t-20">
            {{ formData.remark || '' }}
          </div>
        </div>

        <div class="m-t-30 bg-FF p-40  b-r-10">
          <van-row class="p-t-20 p-b-20" justify="space-between" align="center" :style="{borderTop:index != 0 ? '1px solid #eee' : ''}" type="flex" v-for="(item,index) in list" :key="index">
            <van-col class="font-30 cor-33 font-weight-400">
              {{ item.lable }}
            </van-col>
            <van-col class="font-30 cor-33 font-weight-600">
              {{ item.value }}
            </van-col>
          </van-row>
        </div>
      </div>
    </div>

    <div class="h-140" v-if="formData.confirm == '1'">
      <div class="bottom-bar">
        <van-button @click="verify" :disabled="formData.isConfirmed == '1'" type="primary" class="m-t-30" round block>{{ formData.isConfirmed == '1' ? '已 确 认' : '确 认 无 误' }}</van-button>
      </div>
    </div>


  </div>
</template>
<script>
import {viewNoteInfo, confirmNoteInfo} from '@/api/paySheet'
import {getDictDataByType} from "@/api/dict";

export default {
  data() {
    return {
      errMsg: null,
      formData: {},
      list: [],
      confirm: null
    }
  },
  created() {
    this.init()

  },
  methods: {
    init() {
      viewNoteInfo({id: this.$route.query.id}).then(res => {
        this.formData = res.data
        console.log(this.formData)
        getDictDataByType('salary_note').then(dict => {
          let arr = []
          for (let key in res.data) {
            const lable = dict.data.find(item => item.dictValue === key)?.dictLabel
            const sort = dict.data.find(item => item.dictValue === key)?.dictSort
            if (lable) {
              arr.push({
                lable,
                value: res.data[key],
                sort
              })
            }
          }
          // 排序
          arr.sort((a, b) => a.sort - b.sort)
          this.list = arr
        })
      }).catch(err => {
        this.errMsg = err
      })

    },
    verify() {
      // 弹窗提示
      this.$dialog.confirm({
        message: '工资条确认无误吗？',
      }).then(() => {
        confirmNoteInfo({id: this.$route.query.id}).then(res => {
          this.$toast.success('确认成功')
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.bottom-bar {
  position: fixed;
  line-height: 140px;
  background: #fff;
  height: 140px;
  line-height: 140px;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  z-index: 1000;
}
</style>